<template>
  <section class="ma-4 ma-md-8">
    <t-page-title title="Administradores | Criação" />
    <v-row justify="center" align="center">
      <v-col>
        <form-admin
          v-if="model"
          v-model="model"
          :readonly="false"
          :editing="true"
          @submit="submit"
        />
      </v-col>
    </v-row>
  </section>
</template>

<script lang="ts" setup>
import { ref } from 'vue'
import AdminService, { AdminUpdateRequest } from '@/services/AdminService'
import { useLoader } from '@/stores/loader'
import { useSnackBar } from '@/stores/snackbar'
import { useRouter } from 'vue-router'
import FormAdmin from './form-admin.vue'
import TPageTitle from '@/components/TPageTitle.vue'
import Role from '@/types/Role'
import Ability from '@/types/Ability'

const loader = useLoader()
const router = useRouter()
const snackbar = useSnackBar()

const model = ref<AdminUpdateRequest>({
  producer_ids: [] as string[],
  roles: [] as Role[],
  abilities: [] as Ability[],
} as AdminUpdateRequest)

async function submit(model: AdminUpdateRequest) {
  try {
    loader.increment()

    await (new AdminService()).store(model)

    snackbar.show(
      'Usuário criado com sucesso',
      'success',
    )

    router.push({ name: 'list-admins' })
  } finally {
    loader.decrement()
  }
}
</script>
